// Video play/pause toggle button
//------------------------------------------------------------------------
export default class VideoToggle {
  constructor(selector) {
    this.toggles = document.querySelectorAll('[data-controls-video]');

    if (!this.toggles) {
      // console.warn(`Unable to initialize video toggles, no matching elements for “${selector}”`);
      return false;
    }

    // Don’t autoplay if user has “prefers-reduced-motion” enabled
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.toggles.forEach((el) => {
      this.init(el);
    });
  }

  init(el) {
    let videoSelector = el.getAttribute('data-controls-video');
    // The selector needs to be >= 2 characters:
    // - Single-letter class
    // - Single-letter ID
    // - Any attribute selector needs at least “[]”
    // Note: “a” or “p” would never work since they aren’t <video> elements
    if (!videoSelector || videoSelector.length < 2) {
      console.warn(`“${videoSelector}” is not a valid selector for the video toggle target`);
      return false;
    }

    let video = document.querySelector(videoSelector);

    if (!video) {
      // console.warn(`Unable to initialize video toggle, no matching video element for “${this.video}”`);
      return false;
    }

    if (this.prefersReducedMotion) {
      video.pause();
    }

    // Update toggle class once video starts playing (happens when modal is first opened)
    // https://github.com/Threespot/nmad/issues/157
    video.addEventListener('play', () => {
      el.classList.toggle('is-paused', video.paused);
    });

    // Add click event listener to toggle
    el.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else if (video.readyState >= 3) {
        video.pause();
      }

      // Toggle class on button so we can change the text and icon with CSS
      el.classList.toggle('is-paused', video.paused);
    });

    // Listen for video end event to update the toggle class
    video.addEventListener('ended', () => {
      this.el.classList.add('is-paused');
    });

    // Listen for video load event from responsive-video.js
    document.documentElement.addEventListener('video-loaded', () => {
      el.classList.toggle('is-paused', video.paused);
    });
  }
}

// Init
new VideoToggle();